import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { Suspense } from "react";
import { Spin } from "antd";
import MyRouter from "./router/MyRouter";
import { persistor, store } from "./redux/store";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GoogleMapsProvider } from "./services/googleMaps";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'test';

const App = () => {
  return (
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <GoogleMapsProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<Spin size={"large"} fullscreen />}>
              <MyRouter />
            </Suspense>
          </PersistGate>
        </Provider>
      </GoogleMapsProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
